import { styled } from "styled-components";
import { Campo } from "../../services/tipos";
import { useState } from "react";
import {
  FaInfoCircle,
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
  FaTimes
} from "react-icons/fa";

export const AlertContainer = styled.div<{ type: 'info' | 'success' | 'warning' | 'danger' }>`
  padding: 1rem;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  border-left: 5px solid;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 1rem;

  ${props => {
    switch (props.type) {
      case 'info':
        return `
          background-color: #e7f5ff;
          border-color: #4dabf7;
          color: #1864ab;
        `;
      case 'success':
        return `
          background-color: #ebfbee;
          border-color: #40c057;
          color: #2b8a3e;
        `;
      case 'warning':
        return `
          background-color: #fff9db;
          border-color: #ffd43b;
          color: #e67700;
        `;
      case 'danger':
        return `
          background-color: #fff5f5;
          border-color: #ff8787;
          color: #c92a2a;
        `;
      default:
        return `
          background-color: #f8f9fa;
          border-color: #adb5bd;
          color: #495057;
        `;
    }
  }}
`;

const AlertIcon = styled.div`
  font-size: 1.5rem;
  margin-top: 0.2rem;
  flex-shrink: 0;
`;

const AlertContent = styled.div`
  flex: 1;
`;

const AlertTitle = styled.h5`
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
`;

const AlertMessage = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
  align-self: start;

  &:hover {
    opacity: 1;
  }
`;

interface AlertFieldProps {
  campo: Campo;
}

export const AlertField: React.FC<AlertFieldProps> = ({ campo }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const getDefaultIcon = () => {
    switch (campo.alertType) {
      case 'info':
        return <FaInfoCircle />;
      case 'success':
        return <FaCheckCircle />;
      case 'warning':
        return <FaExclamationTriangle />;
      case 'danger':
        return <FaTimesCircle />;
      default:
        return <FaInfoCircle />;
    }
  };

  return (
    <AlertContainer type={campo.alertType || 'info'}>
      <AlertIcon>
        {campo.alertIcon || getDefaultIcon()}
      </AlertIcon>
      <AlertContent>
        {campo.alertTitle && <AlertTitle>{campo.alertTitle}</AlertTitle>}
        <AlertMessage>{campo.alertMessage}</AlertMessage>
      </AlertContent>
      {campo.alertDismissible && (
        <CloseButton onClick={() => setVisible(false)}>
          <FaTimes />
        </CloseButton>
      )}
    </AlertContainer>
  );
};
